module.exports = __webpack_public_path__ + "img/red.59fd1d4c.svg";